export default {"src":"/_next/static/media/happy-face.b98773de.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};